/* ═══════════════════════════════════════════
   HOLYRON — Cart Drawer JS
   assets/hl-cart.js
═══════════════════════════════════════════ */

(function () {
  'use strict';

  const SHIPPING_THRESHOLD = 0;    // 0 = livraison toujours offerte
  const COUNTDOWN_DURATION  = 8 * 60; // secondes

  /* ── Refs ── */
  function el(id) { return document.getElementById(id); }

  /* ── Format monnaie ── */
  function fmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ══════════════════════════════════════════
     COUNTDOWN
  ══════════════════════════════════════════ */
  function initCountdown() {
    const KEY = 'hl_cart_exp';
    let exp = parseInt(sessionStorage.getItem(KEY) || '0', 10);
    const now = Date.now();
    if (!exp || exp < now) {
      exp = now + COUNTDOWN_DURATION * 1000;
      sessionStorage.setItem(KEY, exp);
    }

    const timeEl = el('hlCdTime');
    if (!timeEl) return;

    function tick() {
      const left = Math.max(0, Math.floor((exp - Date.now()) / 1000));
      if (left === 0) {
        exp = Date.now() + COUNTDOWN_DURATION * 1000;
        sessionStorage.setItem(KEY, exp);
      }
      const m = String(Math.floor(left / 60)).padStart(2, '0');
      const s = String(left % 60).padStart(2, '0');
      timeEl.textContent = m + ':' + s;
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ══════════════════════════════════════════
     CART API
  ══════════════════════════════════════════ */
  async function apiGet() {
    const r = await fetch('/cart.js');
    return r.json();
  }

  async function apiChange(line, qty) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity: qty })
    });
    return r.json();
  }

  /* ══════════════════════════════════════════
     RENDER
  ══════════════════════════════════════════ */
  function renderItems(cart) {
    const wrap = el('hlItems');
    if (!wrap) return;

    if (cart.item_count === 0) {
      wrap.innerHTML = `
        <div class="hl-empty">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
            <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18M16 10a4 4 0 01-8 0"/>
          </svg>
          <span>Votre panier est vide</span>
          <a href="/collections/all">Découvrir nos produits</a>
        </div>`;
      return;
    }

    wrap.innerHTML = cart.items.map(function (item, i) {
      const img    = item.featured_image && item.featured_image.url
        ? item.featured_image.url.replace(/(\.\w+(\?.*)?$)/, '_200x200_crop_center$1')
        : '';
      const isFree = item.final_price === 0 && item.original_price > 0;
      const saved  = item.original_price - item.final_price;

      return `
        <div class="hl-item" data-line="${i + 1}">
          <div class="hl-item-img">
            ${img
              ? `<img src="${img}" alt="${item.title}" loading="lazy">`
              : '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>'
            }
          </div>
          <div class="hl-item-body">
            <div class="hl-item-name">${item.product_title}</div>
            ${item.variant_title && item.variant_title !== 'Default Title'
              ? `<div class="hl-item-variant">${item.variant_title}</div>`
              : ''}
            <div class="hl-item-pricing">
              <span class="hl-item-price">${fmt(item.final_price)}</span>
              ${item.original_price > item.final_price
                ? `<span class="hl-item-compare">${fmt(item.original_price)}</span>`
                : ''}
            </div>
            ${saved > 0 ? `<div class="hl-item-savings">Économisez ${fmt(saved)}</div>` : ''}
            <div class="hl-item-qty">
              <button class="hl-qty-btn" onclick="hlQty(${i + 1}, ${item.quantity - 1})" aria-label="Moins">−</button>
              <span class="hl-qty-val">${item.quantity}</span>
              <button class="hl-qty-btn" onclick="hlQty(${i + 1}, ${item.quantity + 1})" aria-label="Plus">+</button>
            </div>
            ${isFree ? `<div class="hl-item-badge">🎁 Offert avec votre commande</div>` : ''}
          </div>
          ${isFree
            ? `<div class="hl-free-badge">Offert</div>`
            : `<button class="hl-item-del" onclick="hlRemove(${i + 1})" aria-label="Supprimer">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/>
                </svg>
               </button>`
          }
        </div>`;
    }).join('');
  }

  function renderFooter(cart) {
    /* Total */
    const totalEl = el('hlTotalAmt');
    const ctaPrice = el('hlCtaPrice');
    const formatted = fmt(cart.total_price);
    if (totalEl)   totalEl.textContent   = formatted;
    if (ctaPrice)  ctaPrice.textContent  = formatted;

    /* Shipping bar — toujours offerte dès qu'il y a un produit */
    const barFill = el('hlBarFill');
    const shippingText = el('hlShippingText');
    if (barFill) barFill.style.width = cart.item_count > 0 ? '100%' : '0%';
    if (shippingText) {
      shippingText.innerHTML = cart.item_count > 0
        ? '🎉 <strong>Livraison offerte</strong> incluse dans votre commande !'
        : 'Ajoutez un produit pour bénéficier de la <strong>livraison offerte</strong>';
    }

    /* Réductions */
    const discRow = el('hlDiscountRow');
    const discAmt  = el('hlDiscountAmt');
    const discTag  = el('hlDiscountTag');
    if (discRow) {
      if (cart.total_discount > 0) {
        discRow.hidden = false;
        if (discAmt) discAmt.textContent = '− ' + fmt(cart.total_discount);
        if (discTag && cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
          discTag.textContent = cart.cart_level_discount_applications[0].title;
        }
      } else {
        discRow.hidden = true;
      }
    }

    /* Compteur header */
    document.querySelectorAll('[data-cart-count], .cart-count-bubble').forEach(function (el) {
      el.textContent = cart.item_count || '';
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
  }

  async function renderCart() {
    try {
      const cart = await apiGet();
      renderItems(cart);
      renderFooter(cart);
    } catch (e) {
      console.warn('[HlCart] Erreur render:', e);
    }
  }

  /* ══════════════════════════════════════════
     OPEN / CLOSE
  ══════════════════════════════════════════ */
  window.hlCartOpen = function () {
    const drawer  = el('hlDrawer');
    const overlay = el('hlOverlay');
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    renderCart();
  };

  window.hlCartClose = function () {
    const drawer  = el('hlDrawer');
    const overlay = el('hlOverlay');
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  };

  /* ══════════════════════════════════════════
     QUANTITÉ / SUPPRIMER
  ══════════════════════════════════════════ */
  window.hlQty = async function (line, qty) {
    if (qty < 0) return;
    await apiChange(line, qty);
    renderCart();
  };

  window.hlRemove = async function (line) {
    await apiChange(line, 0);
    renderCart();
  };

  /* ══════════════════════════════════════════
     INTERCEPTION — niveau fetch (universel)
  ══════════════════════════════════════════ */

  /* Intercepte TOUS les appels fetch vers /cart/add.js
     Fonctionne avec Dawn, AJAX, et les sections fp-hero */
  var _origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url  = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';

    if (url.indexOf('/cart/add') !== -1) {
      return _origFetch.apply(window, args).then(function (response) {
        if (response.ok) {
          /* Clone pour ne pas consommer le body */
          var clone = response.clone();
          /* Petit délai pour laisser Shopify mettre à jour le panier */
          setTimeout(hlCartOpen, 300);
          return clone;
        }
        return response;
      });
    }

    return _origFetch.apply(window, args);
  };

  document.addEventListener('DOMContentLoaded', function () {
    initCountdown();

    /* Clic sur l'icône panier */
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest(
        '#cart-icon-bubble, [href="/cart"], [data-cart-toggle], .header__icon--cart'
      );
      if (trigger) {
        e.preventDefault();
        e.stopImmediatePropagation();
        hlCartOpen();
      }
    }, true);

    /* Fermer avec Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hlCartClose();
    });

    /* Masquer le drawer Dawn s'il s'ouvre quand même */
    var dawnDrawer = document.querySelector('cart-drawer');
    if (dawnDrawer) {
      new MutationObserver(function () {
        if (dawnDrawer.hasAttribute('open') || dawnDrawer.classList.contains('active')) {
          dawnDrawer.removeAttribute('open');
          dawnDrawer.classList.remove('active');
        }
      }).observe(dawnDrawer, { attributes: true });
    }
  });

})();
